import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Spinner } from '../../ui/spinner';
import { Alert, AlertDescription } from '../../ui/alert';
import UserStateSection from './UserStateSection';

const SECTION_TITLES = { user: 'USER INFO', payments_deposits: 'DEPOSITS', crypto_deposits: 'CRYPTO DEPOSITS', free_spins_all: 'FREE SPINS', bonuses: 'BONUSES', documents: 'DOCUMENTS' };

const UserStatePanel = ({ userState, loading, error }) => {
  if (loading) return <Card><CardContent className="p-4"><div className="flex items-center justify-center py-6"><Spinner size="sm" /><span className="ml-3 text-sm text-ink-dim">Loading user data...</span></div></CardContent></Card>;
  if (error) return <Card><CardContent className="p-4"><Alert variant="error"><AlertDescription>{error}</AlertDescription></Alert></CardContent></Card>;
  if (!userState || !userState.data || Object.keys(userState.data).length === 0) return <Card><CardContent className="p-4"><span className="text-sm text-ink-dim">No user data available</span></CardContent></Card>;

  const parseData = (dataType, stateData) => {
    try {
      if (!stateData.data) return null;
      let data = stateData.data;
      if (typeof data === 'string') data = JSON.parse(data);
      switch (dataType) {
        case 'user': return data.softswiss || data;
        case 'documents': case 'payments_deposits': case 'free_spins_all': return (data.data && Array.isArray(data.data)) ? data.data.map(item => item.softswiss || item) : data;
        case 'crypto_deposits': return (data.data && Array.isArray(data.data)) ? data.data : data;
        case 'bonuses': return (data.softswiss && Array.isArray(data.softswiss)) ? data.softswiss : data;
        default: return data;
      }
    } catch { return null; }
  };

  const dataTypes = Object.keys(userState.data).sort();

  return (
    <Card className="h-fit max-h-[calc(100vh-150px)] overflow-auto">
      <CardContent className="p-3">
        <div className="mb-3">
          <h3 className="text-sm font-bold">User State</h3>
          {userState.fetched_at && <span className="text-[10px] text-ink-dim">Fetched: {new Date(userState.fetched_at).toLocaleString()}</span>}
        </div>
        {dataTypes.map((dataType) => {
          const stateData = userState.data[dataType];
          const parsedData = parseData(dataType, stateData);
          if (!parsedData) return null;
          return <UserStateSection key={dataType} type={dataType} title={SECTION_TITLES[dataType] || dataType.toUpperCase()} data={parsedData} />;
        })}
      </CardContent>
    </Card>
  );
};

export default UserStatePanel;
